import colors from "shared/theme/colors";

export const darkTheme = {
  themeName: "dark",

  /// ///////////////////////////////////////
  // Use SPOR components and it's color variables if possible
  // If component is custom or overwritten, use the following color variables
  // Don't create color variables inside your custom components;
  // Create them here, supported by appPalette.ts
  // Don't even think about using a color without a variable
  /// ///////////////////////////////////////

  // BACKGROUND
  colorBackgroundBase: colors.teal1200,
  colorBackgroundMain: colors.teal1100,
  colorBackgroundSecondary: colors.teal900,
  colorBackgroundTertiary: colors.teal800,

  // TEXT
  colorTextMain: colors.white,
  colorTextSecondary: colors.seaMist,
  colorTextTertiary: colors.whiteAlpha["700"],
  colorTextDisabled: colors.whiteAlpha["400"],
  colorTextInverted: colors.teal1000,
  colorSporTextInverted: colors.raven,

  // OUTLINES
  colorOutlineMain: colors.whiteAlpha["400"],
  colorOutlineSecondary: colors.whiteAlpha["100"],
  colorOutlineFocus: colors.azure,
  colorOutlineInverted: colors.blackAlpha["400"],

  // Icons
  colorIconMain: colors.white,
  colorIconSecondary: colors.coralGreen["200"],
  colorIconTertiary: colors.whiteAlpha["700"],
  colorIconDisabled: colors.whiteAlpha["400"],
  colorIconInverted: colors.teal1000,
  colorSporIconInverted: colors.raven,

  // SEMANTICS
  // Alarm 1
  colorAlarm: colors.rose,
  colorAlarmPulse: colors.raspberry,
  colorAlarmFill: colors.maroon,
  colorAlarmFillPulse: colors.burgundy,
  colorAlarmOutline: colors.crimson,
  colorAlarmTextMain: colors.pink,
  colorAlarmTextSecondary: colors.lightRed,
  colorAlarmTextTertiary: colors.aubergine,

  // Alarm 2
  colorSecondaryAlarm: colors.saffron,
  colorSecondaryAlarmPulse: colors.pumpkin,
  colorSecondaryAlarmFill: colors.toast,
  colorSecondaryAlarmFillPulse: colors.chocolate,
  colorSecondaryAlarmOutline: colors.russet,
  colorSecondaryAlarmTextMain: colors.bisque,
  colorSecondaryAlarmTextSecondary: colors.champagne,
  colorSecondaryAlarmTextTertiary: colors.toast,

  // Warning
  colorWarning: colors.banana,
  colorWarningPulse: colors.burntYellow,
  colorWarningFill: colors.olive,
  colorWarningFillPulse: colors.coffee,
  colorWarningOutline: colors.bronze,
  colorWarningTextMain: colors.cornsilk,
  colorWarningTextSecondary: colors.primrose,
  colorWarningTextTertiary: colors.olive,

  // Success
  colorSuccess: colors.blueGreen,
  colorSuccessPulse: colors.azure,
  colorSuccessFill: colors.jungle,
  colorSuccessFillPulse: colors.darkTeal,
  colorSuccessOutline: colors.pine,
  colorSuccessTextMain: colors.mint,
  colorSuccessTextSecondary: colors.coralGreen,
  colorSuccessTextTertiary: colors.night,

  // Info
  colorInfo: colors.glacier,
  colorInfoPulse: colors.blueberry,
  colorInfoFill: colors.royal,
  colorInfoFillPulse: colors.navy,
  colorInfoOutline: colors.ocean,
  colorInfoTextMain: colors.icyBlue,
  colorInfoTextSecondary: colors.cloudy,
  colorInfoTextTertiary: colors.royal,

  // Neutral
  colorNeutral: colors.blueGreen,
  colorNeutralPulse: colors.azure,
  colorNeutralFill: colors.jungle,
  colorNeutralFillPulse: colors.darkTeal,
  colorNeutralOutline: colors.pine,
  colorNeutralTextMain: colors.mint,
  colorNeutralTextSecondary: colors.coralGreen,
  colorNeutralTextTertiary: colors.night,

  // System
  colorSystem: colors.violet400,
  colorSystemPulse: colors.violet500,
  colorSystemFill: colors.violet900,
  colorSystemFillPulse: colors.violet1000,
  colorSystemOutline: colors.violet700,
  colorSystemTextMain: colors.violet50,
  colorSystemTextSecondary: colors.violet200,
  colorSystemTextTertiary: colors.violet1100,

  // Transparent
  colorTransparentFill: "transparent",
  colorTransparentOutline: colors.whiteAlpha["100"],
  colorTransparentTextMain: colors.white,

  // Transparent Inverted
  colorTransparentInvertedFill: "transparent",
  colorTransparentInvertedOutline: colors.blackAlpha["400"],
  colorTransparentInvertedTextMain: colors.night,
  colorTransparentInvertedTextTertiary: colors.night,

  // Ghost (same shape as light theme; in dark mode visually like transparent)
  colorGhostFill: "transparent",
  colorGhostOutline: colors.whiteAlpha["100"],
  colorGhostTextMain: colors.white,

  // Alerts counter (badge)
  colorAlertsCounterWarningBackground: colors.burntYellow,
  colorAlertsCounterSuccessBackground: colors.pine,
  colorAlertsCounterTextOnColor: colors.white,
  colorAlertsCounterWarningText: colors.black,

  // Interaction states
  colorSelected: colors.darkTeal,
  filterHover: "brightness(1.3) contrast(0.7)",
  filterSelected: "brightness(1.5) contrast(0.9)",

  // Surface colors
  surfaceSelected: colors.whiteAlpha["50"],
  surfaceHover: colors.whiteAlpha["100"],
  surfaceDefault: colors.night,
  surfaceDisabled: colors.whiteAlpha["100"],

  // EXTRA
  skeletonElementColor: colors.jungle,
  boxShadow: "0px 2px 12px #010b0a99",
  dropShadow: "drop-shadow(0px 2px 12px #010b0a99)", // Used for filter, can't use boxShadow as it is not supported in filter
  overlayColor: "#000000b3", // Aka rgba(0, 0, 0, 0.7). Keep as hex as it is used in calculation
  trainMapStretchBuilder: colors.jungle,
  trainSVGStrokeColor: colors.white,
};

export type DarkTheme = typeof darkTheme;
